import React, { Component } from 'react';
import './_styles.scss';
import { Button } from 'packages/components';

export default class ButtonTelmex extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { icon, onClick } = this.props;

    return (
      <Button 
        className="landing-telmex__button-telmex focusable"
        onClick={onClick ? function() { onClick(); } : null}
      >
        {icon && <img src={icon} alt="Telmex" />}
      </Button>
    );
  }
}


// WEBPACK FOOTER //
// ./src/authentication/components/LandingTelmex/ButtonTelmex/index.jsx